import type { SelectListUser } from '../../containers/CreateMessage/createMessageSlice/types';
import { objectToQueryParams } from '../../utils/format';
import type { IndexInterface } from '../groupsAPI/types';
import { legacyUserApi } from '../utils/core';
import type { UserById } from './types';

export type GetUserQuery = {
  sort?: string;
  search?: string;
  skip?: number;
  menuitem?: string;
  limit?: number;
} & IndexInterface;

export const getUserById = (id: number) => {
  return legacyUserApi.getSingle<UserById>(id);
};

export const getAllUsers = (query?: GetUserQuery) => {
  return legacyUserApi.performExtra<SelectListUser[]>({
    method: 'get',
    extraResource: `?${objectToQueryParams(query)}`,
  });
};
